import Contact from "../contact/Contact";
export default function Profile() {
    return <Contact />;
}
